/**
 * Schema of TipoOcorrencia
 * @author Simpli CLI generator
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import TipoVeiculo from '@/model/resource/TipoVeiculo'

export default (model: TipoVeiculo): Schema => ({
  idTipoVeiculo: {
    content: model.idTipoVeiculo,
    editable: false,
  },

  nome: {
    content: model.nome,
  },

  nomeAlt: {
    model: 'nome',
    content: model.nome,
    textContent: null,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '63',
    },
  },

  ativo: {
    content: bool(model.ativo),
    input: InputType.CHECKBOX,
  },
})
